<script context=module>

</script>

<script>
  import { classes } from '../helpers';
  import Link from './Link.svelte';

  export let item;
  export let nolink = true;

  $: id = item && item.id;
  $: type = item && (item._type || item.type);
  $: format = item && item.format;
  $: display = item && item.display;

  $: href = !nolink || item.email;
</script>

{#if item}
<Link {href}>
  <data class={classes('user', type, format)} value={id || ''}>
    <slot>{display}</slot>
  </data>
</Link>
{/if}
